import Vue from 'vue';
import $ from 'jquery';
import { stringify } from 'csv-stringify';
import Utils from 'src/utils/general';
import MathUtils from 'src/utils/math';
import { mapGetters } from 'vuex';
export default Vue.extend({
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        ...mapGetters(['currentModel', 'currentAnalysis', 'currentProject'])
    },
    methods: {
        downloadSegmentConceptFreqMatrix(event) {
            let $target = $(event.target).closest('div.button');
            $target.addClass('loading');
            const topics = ['', ...Object.keys(this.currentModel['topics'])];
            const buildConceptSegmentMatrix = function* (topics, metadataInfo) {
                yield topics;
                for (const field of Object.keys(metadataInfo)) {
                    if (metadataInfo[field]['segments'] === false) {
                        continue; // No segments here
                    }
                    const segments = Object.keys(metadataInfo[field]['frequencies']);
                    for (const segment of segments) {
                        let result = [`${field}: ${segment}`];
                        for (const topic of topics.slice(1)) {
                            result.push(metadataInfo[field]['topics'][segment][topic] || 0);
                        }
                        yield result;
                    }
                }
            };
            stringify([...buildConceptSegmentMatrix(topics, this.currentModel['metadata_info'])], (_, output) => {
                Utils.downloadCsv(output, 'concept-segment-frequency-matrix');
            });
            $target.removeClass('loading');
        },
        downloadSegmentConceptNPMIMatrix(event) {
            let $target = $(event.target).closest('div.button');
            $target.addClass('loading');
            const topics = ['', ...Object.keys(this.currentModel['topics'])];
            const buildConceptSegmentMatrix = function* (topics, model) {
                const metadataInfo = model['metadata_info'];
                yield topics;
                for (const field of Object.keys(metadataInfo)) {
                    if (metadataInfo[field]['segments'] === false) {
                        continue; // No segments here
                    }
                    const segments = Object.keys(metadataInfo[field]['frequencies']);
                    for (const segment of segments) {
                        let result = [`${field}: ${segment}`];
                        for (const topic of topics.slice(1)) {
                            result.push(MathUtils.calculateNormalisedPMI(metadataInfo[field]['topics'][segment][topic] || 0, metadataInfo[field]['frequencies'][segment], model['topics'][topic]['frequency'], model['stats']['n_frames']));
                        }
                        yield result;
                    }
                }
            };
            stringify([...buildConceptSegmentMatrix(topics, this.currentModel)], (_, output) => {
                Utils.downloadCsv(output, 'concept-segment-correlation-matrix');
            });
            $target.removeClass('loading');
        }
    }
});
